import { SmartTooltip } from '@/components/extension/smart-tooltip'
import { TagThumbnail } from '@/components/ui/tag-thumbnail'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn, formatPrice } from '@/lib/utils'
import { InfoIcon } from 'lucide-react'
import Image from 'next/image'

type Props = {
  regularPrice: number
  comparePrice: number
  salePercent?: number
  isCoolClubSale?: boolean
  tags?: Record<string, string>
}

export const ProductInfoPrice = ({
  regularPrice,
  comparePrice,
  salePercent,
  isCoolClubSale,
  tags,
}: Props) => {
  const productTags = Array.isArray(tags) ? tags : Object.keys(tags || {})
  console.log(productTags)
  return (
    <div className='mt-4 lg:mt-5'>
      {comparePrice && comparePrice !== regularPrice ? (
        <del className='mb-1 font-sans text-xs text-neutral-400 lg:mb-2 lg:text-base'>
          {formatPrice(comparePrice)}
        </del>
      ) : null}
      <div className='flex items-center gap-2 lg:gap-4'>
        {isCoolClubSale ? (
          <Image
            src={ImageHelper.getImageUrl('/image/December2024/mceclip0_21.png')}
            alt='Price'
            width={24}
            height={24}
            unoptimized
            className='h-6 w-6'
          />
        ) : null}
        <p
          className={cn(
            'font-sans text-lg font-bold leading-3 text-neutral-900 lg:text-[28px] lg:leading-5',
            isCoolClubSale ? 'text-primary' : ''
          )}
        >
          {formatPrice(regularPrice)}
        </p>
        <div className='flex items-center gap-1'>
          {salePercent && salePercent > 0 ? (
            <TagThumbnail
              title={`-${salePercent}%`}
              size='small'
              className='lg:h-7 lg:text-base lg:leading-5'
            />
          ) : null}
          {productTags.includes('Good Price') ||
          productTags.includes('goodprice') ? (
            <SmartTooltip
              content={'Sản phẩm giá tốt'}
              side='top'
              trigger='click'
            >
              <InfoIcon className='h-3.5 w-3.5 cursor-pointer' />
            </SmartTooltip>
          ) : null}
        </div>
        {isCoolClubSale ? (
          <SmartTooltip
            content={'Giá chỉ dành riêng cho thành viên CoolClub'}
            side='top'
            trigger='click'
          >
            <InfoIcon className='h-3.5 w-3.5 cursor-pointer' />
          </SmartTooltip>
        ) : null}
      </div>
    </div>
  )
}
